import clsx from "clsx";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowUpRightFromSquare } from "@awesome.me/kit-70c1f0055f/icons/classic/regular";
import { useOsNavigate } from "@/components/ui/os-layout";
import { guardiansAlertsUrl, type GuardiansAlertsUrlInput } from "@/navigation/apps/guardiansLocation";

export interface OpenInGuardiansButtonProps {
  missionId?: string | null;
  taskId?: string | null;
  item?: string | null;
  auditId?: string | null;
  label?: string;
  className?: string;
}

/**
 * Prominent navigation control into the Guardians alerts view.
 */
export function OpenInGuardiansButton({
  missionId,
  taskId,
  item: _item,
  auditId,
  label = "Open in Guardians",
  className,
}: OpenInGuardiansButtonProps) {
  const osNavigate = useOsNavigate();
  const input: GuardiansAlertsUrlInput = { missionId, taskId, alertId: auditId };
  const href = guardiansAlertsUrl(input);

  return (
    <button
      type="button"
      onClick={() => osNavigate(href)}
      data-testid="open-in-guardians-button"
      className={clsx(
        "inline-flex w-full items-center justify-center gap-2 rounded-lg border border-indigo-900/60 bg-indigo-950 px-3 py-1.5 text-sm font-medium text-indigo-100 hover:bg-indigo-900",
        className
      )}
    >
      <span>{label}</span>
      <FontAwesomeIcon icon={faArrowUpRightFromSquare} className="text-[11px]" />
    </button>
  );
}
